<div (click)="dimClick()" class="modal" [ngClass]="{'fade':visible, 'show':visible}" [ngStyle]="{'display':(visible)?'block':'none','background-color':(visible)?'#2d2d2d6e':''}">
  <div class="modal-dialog" (click)="preventPropagation($event)">
      <ng-content></ng-content>
  </div>
</div>
